import { type Product, type RhinoCart } from '@evolutivelabs/rhinoshield-shopify-client'
import { defineStore } from 'pinia'
import { computed, readonly, ref } from 'vue'

import { shopifyCart } from '@/locale'

export const useCartStore = defineStore('cart', () => {
  const cart = ref<null | RhinoCart>(null)
  const totalQuantity = computed(() => cart.value?.rhinoLines.length ?? 0)

  async function initProcess(): Promise<void> {
    cart.value = await shopifyCart.getCart()
  }
  let initSingleton: null | Promise<void> = null
  async function init(): Promise<void> {
    initSingleton ??= initProcess()
    await initSingleton
  }
  void init()

  async function addProductToCart(products: Product[]): Promise<void> {
    await init()
    cart.value = await shopifyCart.addLines(products)
  }

  async function addDiscountCode(discountCode: string): Promise<void> {
    await init()
    cart.value = await shopifyCart.appendDiscountCode(discountCode)
  }

  const deletedLineIds = ref(new Set<string>())
  async function removeRhinoLineFromCart(lineId: string): Promise<void> {
    deletedLineIds.value.add(lineId)
    await init()
    cart.value = await shopifyCart.removeRhinoLine(lineId)
  }

  return {
    totalQuantity: readonly(totalQuantity),
    addProductToCart,
    addDiscountCode,
    removeRhinoLineFromCart,
    deletedLineIds: readonly(deletedLineIds),
    cart,
  }
})
